import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const InfoElementsName: object = {
  'operationsName': { name: 'Einsatzstichwort' },
  'operationsNumber': { name: 'Einsatznummer' },
  'operationsPriorityRights': { name: 'Priorität / Sonderrechte' },
  'operationsLocation': { name: 'Adresse' },
  'operationsAlarmedUnits': { name: 'Alarmierte Gruppen / Benutzer / Standorte' },
  'operationsMessage': { name: 'Meldung' }
}

export const WidgetAlarmInformations: Widget = {
  type: WidgetType.alarmInformations,
  noPadding: true,
  title: 'Alarm Informationen',
  minSize: 8,
  defaultSize: 14,
  icon: 'Apps',
  defaultHeightType: WidgetHeightType.automatic,
  customSettings: {
    settings: {
      sortInfoElements: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomAlarmInfoColumnSorting' },

      showLabels: { type: WidgetSettingType.checkbox, title: 'Label anzeigen', checked: true },
      showOperationsNameIcon: { type: WidgetSettingType.checkbox, title: 'Icon (Einsatzstichwort) anzeigen', checked: false },
      showIcons: { type: WidgetSettingType.checkbox, title: 'Icons anzeigen', checked: true },

      fontSizeOperationsName: { type: WidgetSettingType.number, title: 'Schriftgröße, Einsatzstichwort', value: 56, min: 14, max: 128 },
      fontSizeOther: { type: WidgetSettingType.number, title: 'Schriftgröße, Andere Informationen', value: 28, min: 14, max: 128 }
    },
    sections: [
      {
        label: 'Info-Elemente',
        settings: [
          'sortInfoElements'
        ]
      },
      {
        label: 'Schriften',
        settings: [
          'fontSizeOperationsName',
          'fontSizeOther'
        ]
      },
      {
        label: 'Icons',
        settings: [
          'showOperationsNameIcon',
          'showIcons'
        ]
      }
    ]
  }
}

export default WidgetAlarmInformations
